module.exports = __webpack_public_path__ + "img/flux_300.9789714e.jpg";